module.exports = __webpack_public_path__ + "img/airpa_15.bfd44b56.svg";